import { render, staticRenderFns } from "./OpenCloseChip.vue?vue&type=template&id=7044a420&"
import script from "./OpenCloseChip.vue?vue&type=script&lang=js&"
export * from "./OpenCloseChip.vue?vue&type=script&lang=js&"
import style0 from "./OpenCloseChip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports